import React from 'react';
import styled from '@emotion/styled';

const toggleHeight = 24;
const toggleWidth = 48;
const circleSize = toggleHeight;

const ToggleWrapper = styled.div<{
  active: boolean;
}>`
  width: ${toggleWidth}px;
  height: ${toggleHeight}px;
  border-radius: 16px;
  background: ${(props) => (props.active ? 'var(--colorUIGreen)' : 'var(--colorBlueGray400)')};
  border: solid 1px var(--colorBlueGray800);
  position: relative;
  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1);
  cursor: pointer;
  margin-left: 16px;
`;

const ToggleCircle = styled.div<{
  active: boolean;
}>`
  width: ${circleSize}px;
  height: ${circleSize}px;
  background: #fff;
  border-radius: 50%;
  position: absolute;
  left: ${(props) => (props.active ? `${toggleWidth - circleSize}px` : 0)};
  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1);
  border: solid 1px var(--colorBlueGray100);
  box-sizing: border-box;
`;

interface Props {
  value: boolean;
  onClick?: (value: boolean) => void;
}

const Toggle: React.FunctionComponent<Props> = ({ value, onClick }) => {
  const handleClick = () => {
    onClick && onClick(!value);
  };
  return (
    <ToggleWrapper active={value} onClick={handleClick}>
      <ToggleCircle active={value} />
    </ToggleWrapper>
  );
};

export default Toggle;
